import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_BALANCE_LIST } from '../urls'
import ManthlyBalanceForm from './ManthlyBalanceForm'

export default function ManthlyBalanceCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: MANTHLY_BALANCE_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyBalanceForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
